import { Customer } from '../../../../domain/customers/customer';
import CitySelector from '../../../cities/components/CitySelector';
import CheckBoxField from '../../../shared/components/forms/CheckBoxField';
import TextField from '../../../shared/components/forms/TextField';
import ClassificationSelector from '../ClassificationSelector';

interface Props {
    customer: Customer;
    isNewCustomer: boolean;
    onChange: (name: string, value: string | number | boolean | undefined) => void;
}

export default function CustomerInformationSection({
    customer,
    isNewCustomer,
    onChange: handleInputChange,
}: Props) {
    return (
        <>
            <h5 className='my-3'>Información del Cliente</h5>
            <div className='col-6'>
                <TextField
                    label='Nombre del cliente *'
                    name='commercialName'
                    onChange={handleInputChange}
                    required={true}
                    value={customer.commercialName}
                    key='firstName'
                />
            </div>
            <div className='col-3'>
                <TextField
                    label='Código *'
                    name='code'
                    onChange={handleInputChange}
                    required={true}
                    value={customer.code}
                    key='code'
                />
            </div>

            <div className='col-6'>
                <TextField
                    label='No. Documento *'
                    name='documentNumber'
                    onChange={handleInputChange}
                    required={false}
                    value={customer.documentNumber}
                    key='documentNumber'
                />
            </div>
            <div className='col-6'>
                <TextField
                    label='Dirección'
                    name='address'
                    onChange={handleInputChange}
                    required={false}
                    value={customer.address}
                    key='address'
                />
            </div>
            <div className='col-6'>
                <CitySelector
                    name='cityId'
                    onChange={handleInputChange}
                    value={customer.cityId}
                />
            </div>

            <div className='col-6'>
                <ClassificationSelector
                    name='classification'
                    onChange={handleInputChange}
                    value={customer.classification}
                />
            </div>

            <div className='col-4'>
                <CheckBoxField
                    label='Está Activo? *'
                    name='isActive'
                    onChange={handleInputChange}
                    disabled={isNewCustomer}
                    value={customer.isActive}
                />
            </div>
        </>
    );
}
